export default __webpack_public_path__ + "static/media/nft-icon.3971ff10.png";